import { Controller } from "@hotwired/stimulus";

// Counts selected lot checkboxes and updates the counter display
export default class extends Controller {
  static targets = ["counter"];

  connect() {
    this.updateCounter();
    // Listen for checkbox changes in the parent fieldset
    this.element
      .closest("fieldset")
      ?.addEventListener("change", this.updateCounter.bind(this));
  }

  disconnect() {
    this.element
      .closest("fieldset")
      ?.removeEventListener("change", this.updateCounter.bind(this));
  }

  updateCounter() {
    const fieldset = this.element.closest("fieldset");
    if (!fieldset) return;

    const checkboxes = fieldset.querySelectorAll(
      'input[type="checkbox"][name="field_cycle_line_item[lot_ids][]"]'
    );
    const checkedCount = Array.from(checkboxes).filter(
      (cb) => cb.checked
    ).length;

    if (this.hasCounterTarget) {
      // Get the appropriate translation based on count
      const locale = document.documentElement.lang || "en";
      let text;

      if (checkedCount === 0) {
        text =
          locale === "es" ? "Ningún lote seleccionado" : "No lots selected";
      } else if (checkedCount === 1) {
        text = locale === "es" ? "1 lote seleccionado" : "1 lot selected";
      } else {
        text =
          locale === "es"
            ? `${checkedCount} lotes seleccionados`
            : `${checkedCount} lots selected`;
      }

      this.counterTarget.textContent = text;

      // Update visual styling based on selection
      if (checkedCount === 0) {
        this.counterTarget.classList.add("text-warning");
        this.counterTarget.classList.remove("text-success");
      } else {
        this.counterTarget.classList.remove("text-warning");
        this.counterTarget.classList.add("text-success");
      }
    }
  }
}
